/**
 * EmailCuentasPage — `/activa/email` · el otro canal, con el mismo trato que WhatsApp.
 *
 * Hasta acá el email de las campañas salía de UN SMTP global por variables de entorno
 * (la casilla de Deenex). Todas las marcas mandaban desde el mismo remitente: el cliente
 * recibía un mail de "su" restaurante que venía de otro lado, las respuestas caían en la
 * casilla equivocada, y la reputación del dominio la pagaba cualquiera. Cada marca conecta
 * y guarda SU casilla, igual que conecta su línea de WhatsApp.
 *
 * La gestión (alta, verificación real, prueba) vive en <GestionCasillas>, el MISMO componente
 * que el paso de email del wizard: la casilla se puede configurar sin salir del flujo, y no hay
 * dos formularios SMTP que se desincronicen. Acá sólo va el cromo de la página.
 */

import { Link } from "react-router-dom";
import { Mail, Plus } from "lucide-react";
import { useState } from "react";
import GestionCasillas from "../components/GestionCasillas";

export default function EmailCuentasPage() {
  // el botón "Conectar casilla" del header abre el form dentro del componente; se coordina por key:
  // remontar GestionCasillas con el form ya abierto es más simple que exponer su estado interno.
  const [abrirAlta, setAbrirAlta] = useState(0);

  return (
    <div className="min-h-screen p-4 sm:p-6 md:p-8 animate-fade-in">
      <div className="mx-auto max-w-3xl space-y-5">
        <div className="flex items-start justify-between gap-4 flex-wrap">
          <div>
            <span className="text-[10px] font-bold uppercase tracking-wider px-2 py-0.5 rounded-full bg-violet-50 text-violet-700">
              Campañas por QR · mail
            </span>
            <h1 className="text-2xl md:text-3xl font-bold text-slate-900 mt-2 tracking-tight">Casillas de email</h1>
            <p className="text-sm text-slate-500 mt-1 max-w-xl leading-relaxed">
              Los mails de tus campañas salen desde <strong>tu casilla</strong>, no desde una de Deenex: tus clientes te ven a
              vos como remitente y las respuestas te llegan a vos.
            </p>
          </div>
          <button
            onClick={() => setAbrirAlta((n) => n + 1)}
            className="inline-flex items-center gap-2 h-11 px-5 rounded-xl bg-violet-600 text-white text-sm font-semibold hover:bg-violet-700 transition-colors shadow-sm"
          >
            <Plus size={16} /> Conectar casilla
          </button>
        </div>

        <GestionCasillas key={abrirAlta} abrirAltaAlMontar={abrirAlta > 0} />

        <div className="rounded-2xl border border-slate-100 bg-slate-50/50 p-4 flex items-start gap-3">
          <Mail size={17} className="text-slate-400 flex-shrink-0 mt-0.5" />
          <p className="text-xs text-slate-500 leading-relaxed">
            El email es el canal para quien no te dejó el teléfono. Para WhatsApp,{" "}
            <Link to="/activa/whatsapp" className="text-violet-600 font-semibold hover:underline">conectá una línea acá</Link>.
          </p>
        </div>
      </div>
    </div>
  );
}
